// File: src/components/pages/Dashboard.jsx
// Role router — dispatches to StudentDashboard, InstructorDashboard, or AdminDashboard

import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { AUTH0_NAMESPACE, ROLES } from '../../utils/constants';
import StudentDashboard from './StudentDashboard';
import InstructorDashboard from './InstructorDashboard';
import AdminDashboard from './admin/AdminDashboard';

const Dashboard = () => {
  const { user, getAccessTokenSilently } = useAuth0();
  const userRoles = user?.[`${AUTH0_NAMESPACE}/roles`] || [];
  const isStudent = userRoles.includes(ROLES.SERVICEUSER);
  const isInstructor = userRoles.includes(ROLES.SERVICEPROVIDER);
  const isAdmin = userRoles.includes(ROLES.ADMIN);

  if (isStudent) {
    return <StudentDashboard user={user} getAccessTokenSilently={getAccessTokenSilently} />;
  }
  if (isInstructor) {
    return <InstructorDashboard user={user} getAccessTokenSilently={getAccessTokenSilently} />;
  }
  if (isAdmin) {
    return <AdminDashboard />;
  }
};

export default Dashboard;